import { insertIf } from '@fastre/core/helperFunctions/array'
import { Box, Tab } from '@mui/joy'
import { useUserData } from 'auth'
import { ScrollableTabList, ScrollableTabs } from 'components/scrollableTabs'
import SectionHead from 'components/sectionHead'
import { useSearchParamState } from 'helperFunctions/react'
import { useMemo } from 'react'
import LinkSettings from 'settings/links'
import Automation from './automation'
import EmailTemplates from './emailTemplates'
import fundDisbursementTemplate from './fundDisbursementTemplate'
import ListingConfig from './listingConfig'
import Marketing from './marketing'
import OrgDetails from './orgDetails'
import SpecialConditionSnippets from './SpecialConditionSnippets'
import XeroInteagration from './xeroInteagration'
import ZohoIntegration from './zohoIntegration'

export default () => {
    const { user } = useUserData()
    const [activeTab, setActiveTab] = useSearchParamState('tab', 'Links')

    const tabList: [string, any][] = useMemo(
        () => [
            ['Links', LinkSettings],
            //['Marketing Items', MarketingItemsSettings],
            //['Marketing Packages', MarketingSettings],
            ['Marketing', Marketing],
            //[ 'SMS Templates', SMSTemplates ],
            ['Organisation Settings', OrgDetails],
            ['Actions Settings', ListingConfig],
            ['Automation', Automation],
            ['Xero', XeroInteagration],
            ...insertIf(user.lastName == 'Bleier', ['Zoho', ZohoIntegration]),
            ['Special Condition Snippets', SpecialConditionSnippets],
            ['Fund Disbursement Template', fundDisbursementTemplate],
            ...insertIf(import.meta.env.DEV, ['Email Templates', EmailTemplates] as any),
        ],
        [user.userId],
    )

    return (
        <>
            <Box
                sx={{
                    px: {
                        xs: 2,
                        sm: 4,
                    },
                }}
            >
                <SectionHead title="Settings" />
                <ScrollableTabs
                    value={activeTab}
                    onChange={(e, val) => setActiveTab(val as any)}
                    sx={{
                        mx: -4,
                    }}
                >
                    <ScrollableTabList>
                        {tabList.map(([label]) => (
                            <Tab
                                key={label}
                                value={label}
                            >
                                {label}
                            </Tab>
                        ))}
                    </ScrollableTabList>
                </ScrollableTabs>
                <Box
                    sx={{
                        py: 2, // Padding for top and bottom
                        pt: 3, // Additional padding-top
                    }}
                >
                    {tabList.map(([name, Component]) => (
                        <Box
                            key={name}
                            sx={{
                                display: activeTab == name ? undefined : 'none',
                            }}
                        >
                            <Component />
                        </Box>
                    ))}
                </Box>
            </Box>
        </>
    )
}
